export const NONE_OFFER_OPTION = { _id: null, name: "None" };

export const SHOW_WHEN_OPTIONS = [
  {
    name: "Show after target is gone (completed or not applicable)",
    value: "target_gone",
  },
  {
    name: "Show only after target is completed",
    value: "target_done",
  },
];

export const getDependsOnOfferOptionFromApi = (targeting = {}) => {
  const raw = targeting?.depends_on?.offerId;
  if (!raw) return null;

  if (typeof raw === "object" && raw._id) {
    return {
      _id: String(raw._id),
      name: raw.name || String(raw._id),
      p_offer_id: raw.p_offer_id || "",
      partnerName: raw.provider?.name || raw.partnerName || "",
    };
  }

  return {
    _id: String(raw),
    name: String(raw),
    p_offer_id: "",
    partnerName: "",
  };
};

export const DEFAULT_OFFER_TARGETING = {
  ignore_package_check: false,
  depends_on: {
    offerId: null,
    show_when: "target_gone",
  },
};

export const normalizeOfferTargetingFromApi = (targeting = {}) => {
  const rawOfferId = targeting?.depends_on?.offerId;
  const offerId =
    rawOfferId && typeof rawOfferId === "object"
      ? rawOfferId._id || null
      : rawOfferId || null;
  const ignorePackageCheck = !!targeting?.ignore_package_check;

  return {
    ignore_package_check: ignorePackageCheck,
    depends_on: {
      offerId: offerId ? String(offerId) : null,
      show_when: targeting?.depends_on?.show_when || "target_gone",
    },
  };
};

export const buildOfferTargetingPayload = (targeting = {}) => {
  const offerId = targeting?.depends_on?.offerId || null;
  const ignorePackageCheck = !!targeting?.ignore_package_check;

  return {
    ignore_package_check: ignorePackageCheck,
    depends_on: {
      offerId: offerId || null,
      show_when: targeting?.depends_on?.show_when || "target_gone",
    },
  };
};
